'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasOfficeHoursMessageFromCurrentSession = undefined;

var _getMessageIsApproximatelyFromCurrentSession = require('conversations-schema/pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _isOfficeHoursMessage = require('conversations-schema/pubnub-message/operators/isOfficeHoursMessage');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var hasOfficeHoursMessageFromCurrentSession = exports.hasOfficeHoursMessageFromCurrentSession = function hasOfficeHoursMessageFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var lastOfficeHoursMessage = messages.findLast(_isOfficeHoursMessage.isOfficeHoursMessage);

  return !!(lastOfficeHoursMessage && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(lastOfficeHoursMessage));
};